// extracted by mini-css-extract-plugin
export default {"contentWrapper":"InvestmentGridComponent_contentWrapper__LXE4Y","content":"InvestmentGridComponent_content__SOo71"};